import { events } from '../../events';
import { BaseComponent } from '../../framework/base.component';
import { component } from '../../framework/component.decorator';
import { OnInit } from '../../framework/on-init.interface';
import { video$ } from '../../framework/templating/video.element';
import styles from './recording-canvas.component.scss';

@component({
  selector: 'app-recording-canvas',
  styles,
})
export class RecordingCanvasComponent
  extends BaseComponent<RecordingCanvasComponent>
  implements OnInit
{
  async createInitialComponent(): Promise<HTMLElement | HTMLElement[]> {
    return video$({
      onCreate: (element) => {
        element.autoplay = true;
        element.playsInline = true;
        element.muted = true;
      },
    });
  }

  async onInit() {
    events.on('source-selected', ({ source }) => {
      this.doOnFirstChild<HTMLVideoElement>(
        (video) => (video.srcObject = source)
      );

      requestAnimationFrame(() =>
        document.querySelector('.waves')?.classList.add('hidden')
      );
    });

    events.on('stop-recording', () => {
      document.querySelector('.waves')?.classList.remove('hidden');

      requestAnimationFrame(() => {
        (this.getFirstChild<HTMLVideoElement>()?.srcObject as MediaStream)
          ?.getTracks()
          .forEach((track) => track.stop());

        this.doOnFirstChild<HTMLVideoElement>(
          (video) => (video.srcObject = null)
        );
      });
    });
  }
}
